import { EditTagList } from "@/components/AppGrid/AppTagFilter/EditTagList";
import { Tag } from "@/models/tag";
import { Entity, EntityRecord } from "@/orm/types";
import { ActionIcon, Popover } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useAtomValue } from "jotai";

export const TagPopoverEditor = <T extends EntityRecord = EntityRecord>({
  entity,
  resourceProp,
  label,
  children,
}: {
  entity: Entity<T>;
  resourceProp: string;
  label?: string;
  children?: React.ReactNode;
}) => {
  const { data: item } = useAtomValue(entity.getObserveEntityRecordAtom());

  const resourceTags = item?.[
    resourceProp as unknown as keyof typeof item
  ] as unknown as Tag[];
  const editTagsPopoverDisclosure = useDisclosure(false);

  if (!item) return null;

  return (
    <Popover
      width={240}
      position="bottom-end"
      withArrow
      shadow="md"
      opened={editTagsPopoverDisclosure[0]}
      onChange={() => editTagsPopoverDisclosure[1].toggle()}
    >
      <Popover.Target>
        <ActionIcon
          variant="transparent"
          color="gray"
          onClick={() => editTagsPopoverDisclosure[1].toggle()}
        >
          {children}
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown>
        <EditTagList
          label={label}
          resourceProp={resourceProp}
          initTags={resourceTags}
          entity={entity}
          onUpdateComplete={() => editTagsPopoverDisclosure[1].close()}
        />
      </Popover.Dropdown>
    </Popover>
  );
};
